import { useEffect, useState } from "react";
import * as api from "../../api";
import BlueButton from "../Atoms/BlueButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import SDimg from "../../Components/img/SpeedDating.jpg"
import logo_en from "../../../src/Components/img/logo_en.jpg"
import { makeUrlsAndEmailsLinks } from "../Utils/Format";
import Spinner from "../../Plateforme/Atoms/Spinner";


const EventContainer = styled.div`
  width:100%;
  flex-wrap:wrap;
  display:flex;
  flex-direction:row;
  justify-content: center;
  text-align:left;
  /* margin-bottom: 40px;
  margin-left: 20px; */
  row-gap: 20px;
  & img{
    width:200px;
    margin-right:20px;

  }

  & .cont {
    width:60%;
    padding-right: 20px;

    @media(max-width:600px) {
    width:80%;

   }

   & p {
    white-space:pre-wrap;
   }
  } 
`;

const EventCard = styled.div`
    & p {
        text-align: justify;
        white-space: pre-wrap;
        clear: both;
    }

    & img {
        /* width: 150px; */
        /* height:fit-content; */
        margin: 0 20px 20px 0;
        float:left;
    }

    & span {
        flex-wrap: wrap;  
        clear: both;
    }

    & p {
        margin-top: 20px;
    }

    & a {
        margin:10px 0;
    }

    & h2 {
        /* text-transform:uppercase */
    }
`

const LearnMoreEvent = (props) => {

    const [event, setEvent] = useState(null);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();

    //parse eid from url and get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({id: eventIdFromParam}).then((response) => {
                // console.log("event found :")
                // console.log(response.data);
                response.data.displaytype = (response.data.type === "sde" || response.data.type === "sdo") ? "Speed Dating" : "Le FD100";
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    //if no event, just return a spinner
    if (!event) return <Spinner/>

    // console.log(event);
    const logoUrl = process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + event.logo_path;

    console.log(props.fullUser);

    return (
        <div>
            {event && <>
                <EventContainer >
                    {event._id === "65bbd3474931755ed1c4bbef" ? <>
                        <div className="visuel_cont">
                            {i18n.language === "fr" ?
                                <img className="visuel" src={process.env.REACT_APP_MEDIA_BASE_URL + "speeddating/" + event.image_path} alt={event.title_fr}/>
                            :
                                <img className="visuel" src={logo_en} alt={event.title_en}/>
                            }
                        </div>
                        {i18n.language === "fr" ? <div className="cont">
                            <p >Cette année, <strong>le rendez-vous incontournable du secteur du design et de
                            l’ameublement</strong> contribue à la transformation de l’écosystème du design vers <strong>
                            un nouvel art de vivre responsable</strong> :<br></br><br></br>
                            - Pour répondre aux <strong>mutations du cadre de vie contemporain</strong>, aux <strong>nouveaux
                            usages</strong>, aux exigences d’un design plus respectueux de l’environnement, le
                            SPEED DATING Espace &amp; Métiers d’art 2024 prend le parti du <strong>développement
                            durable</strong>.     <br></br>
                            - Pour offrir aux <strong>architectes, architectes d’intérieur, prescripteurs et
                            donneurs d’ordre</strong> qui souhaitent mener à bien des projets à la fois désirables
                            et répondant à un questionnement légitime sur <strong> un nouvel art de vivre
                            responsable</strong>, le SPEED DATING Espace &amp; Métiers d’art 2024 crée l’opportunité
                            de rencontrer des <strong>entreprises soucieuses de l’impact environnemental</strong> de
                            leur activité.     <br></br><br></br>
                            -  Les entreprises – <strong>fabricants, éditeurs, agenceurs, artisans d’art</strong> – sont des
                            partenaires professionnels d’exception sélectionnés par le SPEED DATING
                            Espace &amp; Métiers d’art 2024 pour leur engagement dans de <strong>nouveaux modèles
                            de production vertueux</strong> et leur offre de <strong>produits, matériaux, techniques et
                            services innovants</strong>.<br></br><br></br>
                            <strong>Ensemble, créez des espaces plus respectueux de l’environnement</strong> !</p> <br/>  
                                        {/* <p >{i18n.language === "fr" ? event.description_fr : event.description_en}</p>  */}
                                        <p>CONTACT<br/>
                            Constance Boury <br/>
                            boury@via.fr<br/>
                            +33144681814</p>
                        </div> : <div className="cont">
                            <p ><strong>This leading event in the design and furnishings sector</strong> is helping to drive the transformation
                            of the design ecosystem towards <strong>a new art of responsible living:</strong><br></br><br></br>
                            - Adapting to changes in contemporary lifestyles, <strong>new uses</strong> and the demands of more
                            environmentally friendly design, the SPEED DATING Interior Design & Fine Crafts 2024 is committed to <strong> sustainable development</strong>.<br></br><br></br>
                            - Offering <strong>architects, interior designers, specifiers and clients</strong> who want to carry out
                            projects that are both desirable and address a range of issues relating to <strong>responsible
                            living</strong>, the SPEED DATING Interior Design & Fine Crafts 2024 provides an opportunity to meet <strong>companies that are concerned
                            about the environmental impact </strong>of their business.<br></br><br></br>
                            - The companies - <strong>manufacturers, editors, interior designers, craftspeople </strong>- are
                            outstanding professional partners selected by the SPEED DATING Interior Design & Fine Crafts 2024 for their dedication to <strong>new,
                            sustainable production models and their range of innovative products, materials,
                            techniques and services</strong>.<br></br><br></br>
                            <strong>Creating more environmentally friendly spaces together!</strong></p><br></br><br></br>
                            <p>CONTACT<br/>
                            Constance Boury <br/>
                            boury@via.fr<br/>
                            +33144681814</p>
                        </div>}
                    </> : <>
                        <EventCard>
                            <div className="flexblock">
                                <div style={{flex: "0 0 250px"}}>
                                    <img src={logoUrl} alt={event.title_fr} />
                                </div>
                                <div>
                                    <h2>{i18n.language === "fr" ? event.title_fr : (event.title_en ? event.title_en : event.title_fr)}</h2><br />
                                    <div style={{whiteSpace:"pre-wrap",textAlign:"justify"}}>{i18n.language === "fr" ? makeUrlsAndEmailsLinks(event.description_fr) : makeUrlsAndEmailsLinks(event.description_en)}</div><br/>
                                </div>
                            </div>
                        </EventCard>
                    </>}
                    {event._id === "65bbd3474931755ed1c4bbef" && <img src={SDimg} alt="Speed Dating"/>}
                </EventContainer>
                <div className="flexblock" style={{textAlign:'center'}}>
                    {new Date(event.inscriptions_end_date).setHours(23, 59, 59) < new Date() ? <div>
                        <h2 style={{marginBottom:'20px'}}>{i18n.language === "fr" ? "Les inscriptions sont closes pour cet événement" : "Registration is closed for this event"}</h2>
                    </div> : <>
                        {props.fullUser ? <>
                            {event._id === "65bbd3474931755ed1c4bbef" && <>
                                {/* CHECKED IF THE USER HAS PAID HERE !!!!! */}
                            {event.popAopen && <div>
                                <h2 style={{marginBottom:'20px'}} >{i18n.language === "fr" ? "Architecte d’intérieur/ Prescripteur/ Donneur d’ordre" : "Architect Interior/ Architect / Specifier "}</h2>
                                    <BlueButton onClick={() => navigate("/evenements/joina?eid="+event._id)}>{i18n.language === "fr" ? "Je m'inscris" : "Register"}</BlueButton>
                                </div>}
                                {event.popBopen && <div>
                                    <h2 style={{marginBottom:'20px'}}>{i18n.language === "fr" ? "Fabricant" : "Manufacturer"}</h2>
                                    <BlueButton onClick={() => navigate("/evenements/joinb?eid="+event._id)}>{i18n.language === "fr" ? "Je m'inscris" : "Register"}</BlueButton>
                                </div>}
                            </>}
                            {event.type === "sdo" && <>
                                {event.popAopen && <div>
                                    <h2 style={{marginBottom:'20px'}}>{i18n.language === "fr" ? "Fabricant / Editeur" : "Manufacturer"}</h2>
                                    <BlueButton onClick={() => navigate("/evenements/sdojoina?eid="+event._id)}>{i18n.language === "fr" ? "Je m'inscris" : "Register"}</BlueButton>
                                </div>}
                                {event.popBopen && <div>
                                    <h2 style={{marginBottom:'20px'}} >{i18n.language === "fr" ? " Designer / Architecte d’intérieur" : "Architect Interior/ Architect / Specifier "}</h2>
                                    <BlueButton onClick={() => navigate("/evenements/sdojoinb?eid="+event._id)}>{i18n.language === "fr" ? "Je m'inscris" : "Register"}</BlueButton>
                                </div>}
                            </>}
                            {event.type === "fd100" && <div>
                                {props.fullUser.user.companyHubspotID ?
                                    <>
                                        <h2 style={{marginBottom:'20px'}}>{i18n.language === "fr" ? "Inscription à l'appel à projet" : "Registration for the call for projects"}</h2>
                                        <BlueButton onClick={() => {api.LogFront("user clicked on 'je m'inscris' on FD1002025");navigate("/evenements/fd100join?eid="+event._id)}}>{i18n.language === "fr" ? "Je m'inscris" : "Register"}</BlueButton>
                                    </>
                                :
                                    <>
                                        <h2 style={{marginBottom:'20px'}}>{i18n.language === "fr" ? "Vous devez créer une entreprise avant de vous inscrire à un événement" : "You need to create a company before registering for an event"}</h2>
                                        <BlueButton onClick={() => navigate("/mycompany")}>{i18n.language === "fr" ? "Créer une entreprise" : "Create a company"}</BlueButton>
                                    </>
                                }
                            </div>}
                        </> : <div>
                            <h2 style={{marginBottom:'20px'}}>{i18n.language === "fr" ? "Connectez-vous pour vous inscrire" : "Log in to register"}</h2>
                            <BlueButton onClick={() => navigate("/login")}>{i18n.language === "fr" ? "S’inscrire ou se connecter pour candidater" : "Register or log in to apply"}</BlueButton>
                        </div>}
                    </>}
                </div>
                {event._id === "67590da5499bcc995c210b40" /*reglement pour fd1002025*/ && <div className="centered">
                    <br/>
                    <a href="/documents/Criteres_Règlement_Le_FD100_2026.pdf" target="_blank" rel="noreferrer">{i18n.language === "fr" ? "Conditions d’inscription" : "Registration conditions"}</a>
                </div>}
            </>}
        </div>
    )
}

export default LearnMoreEvent;